export default "__VITE_ASSET__l3Mn6Qsw__"